module.exports = __webpack_public_path__ + "static/contactpage_sprite-c5614b68dd6fe99892d49eb9106511a0.png";